import { domain } from 'modules/data';
import { memo, useCallback } from 'react';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { useToggleQBooksBudgetsSync } from '../../hooks/useToggleQBooksBudgetsSync';
import DisableSyncMenuItem from '../DisableSyncMenuItem/DisableSyncMenuItem';

const QBooksDisableSyncMenuItem = memo(() => {
    const company = useCompanyBasedOnUrl();

    const { toggleSync, isLoading } = useToggleQBooksBudgetsSync(company);

    const handleDisableSync = useCallback(() => {
        toggleSync(false);
    }, [toggleSync]);

    return (
        <DisableSyncMenuItem
            integrationType={domain.IntegrationType.QBooks}
            disableSync={handleDisableSync}
            disabled={company.isReadonly || isLoading}
        />
    );
});

export default QBooksDisableSyncMenuItem;
